import React from 'react';
import VisitorTabMainApp from './Functionality/VisitorTabMainApp';
import { VISITOR_SUB_VIEW_MODEL } from '../Invitation/Model/Model';
import ActiveRequests from './ActiveRequests';
import VisitorTab from './VisitorTab';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const VisitorTabMain = (props) => {
    const {
        subView,
        setSubView,
        selectedList, setSelectedList,
        searchElement, setSearchElement,
        setCriteria,
        setBodyForExport,
        finalArray, setFinalArray,
        search, setSearch,
        deleteModal, setDeleteModal,
        modified, setModified,
        setShowVisitorModal,
        viewOrigin,
        activeStep,
        showSuccessMsgRef
    } = props;
    const { handleSubViewChange, view, setView } = VisitorTabMainApp({
        setSubView,
        selectedList,
        setSelectedList,
        setFinalArray,
        setSearchElement
    });

    return (
        <>
            {subView === VISITOR_SUB_VIEW_MODEL.VISITORS.VISITORS &&
                <VisitorTab
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    setCriteria={setCriteria}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    finalArray={finalArray}
                    setFinalArray={setFinalArray}
                    search={search}
                    setSearch={setSearch}
                    deleteModal={deleteModal}
                    setDeleteModal={setDeleteModal}
                    modified={modified}
                    setModified={setModified}
                    setShowVisitorModal={setShowVisitorModal}
                    view={view}
                    setView={setView}
                    handleSubViewChange={(value) => {
                        handleSubViewChange(value);
                    }}
                    subView={subView}
                    viewOrigin={viewOrigin}
                    showSuccessMsgRef={showSuccessMsgRef}
                />
            }

            {subView === VISITOR_SUB_VIEW_MODEL.VISITORS.ACTIVE_REQUESTS &&
                <ActiveRequests
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    setCriteria={setCriteria}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    finalArray={finalArray}
                    setFinalArray={setFinalArray}
                    search={search}
                    setSearch={setSearch}
                    deleteModal={deleteModal}
                    setDeleteModal={setDeleteModal}
                    modified={modified}
                    setModified={setModified}
                    setShowVisitorModal={setShowVisitorModal}
                    view={view}
                    setView={setView}
                    handleSubViewChange={(value) => {
                        handleSubViewChange(value);
                    }}
                    subView={subView}
                    viewOrigin={viewOrigin}
                    activeStep={activeStep}
                />
            }

        </>
    );
}

export default VisitorTabMain;
